import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'

import { Loader, Form, TextAreaInput } from '../../../UI'
import UPDATE_LOCAL_TOUR from '../../../../graphql/ActivitySteps/UpdateLocalTourWhatWillDo.graphql'

import { validateRequired } from '../../../../libs/validation'
import { NotificationManager } from 'react-notifications';

graphql(UPDATE_LOCAL_TOUR, {
  name: 'updateLocalTour'
})

class WhatWillDo extends Component {
  state = {
    saving: false,
    whatWeDo: ''
  }

  componentDidMount() {
    this.setState({
      whatWillDo: this.props.currentSteps.whatWeDo
    })
  }

  handleSubmit = values => {
    const { data, updateLocalTour, updateSteps, history } = this.props

    this.setState({
      saving: true
    })

    updateLocalTour({
      variables: {
        id: this.props.currentSteps.id,
        whatWeDo: values.whatWeDo
      }
    }).then(() => {
      this.setState(
        {
          saving: false
        },
        () => {
          updateSteps()
          NotificationManager.success('What we will do updated', 'Success', 5000)
          if (data.allLocalTours && data.allLocalTours[0]) {
            history.push(`/activity-steps/${data.allLocalTours[0].id}/where-will-be`)
          } else {
            history.push('/activity-steps/where-will-be')
          }
        }
      )
    }).catch(err=>NotificationManager.error('Error while updating what we will do', 'Error', 5000))
  }

  render() {
    const { t, loading } = this.props
    const { saving, whatWillDo } = this.state

    if (loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">{t('what_we_do')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger steps-submit-btn"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <label className="steps-screen__form-input-label">{t('activity_description')}</label>

            <TextAreaInput
              id="whatWeDo"
              placeholder={''}
              initialValue={whatWillDo}
              maxChars={800}
              validationFuncs={[validateRequired]}
              labelClass="steps-screen__form-input-label"
            />
          </div>
        </Form>
      </div>
    )
  }
}

const enhance = compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)

export default enhance(WhatWillDo)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/MoreDetails/WhatWillDo.jsx